import { CanActivateFn } from '@angular/router'
import { inject } from '@angular/core'
import { UsersService } from '../users.service'
import { catchError, map, of } from 'rxjs'

export const authGuard: CanActivateFn = (_, state) => {
  const usersService = inject(UsersService)

  return usersService.fetchCurrentUser().pipe(
    map((me) => !!me),
    catchError(() => {
      window.location.href = `/api/oauth-login-public/refresh-login?redirect_url=${encodeURIComponent(state.url)}`
      return of(false)
    })
  )
}
